export default __webpack_public_path__ + "static/media/CT_Paper.dbf01c9f.png";